import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    client: {
        first_name: '',
        last_name: ''
    },
    botId: null,
    allowMessagesGroup: true,
    allowMessagesGroupError: false,
    allowMessagesGroupList: [],
    modelDefault: {
        id: null,
        bot_id: null
    },
    sign: null,
    mailingGroups: [],
    mailingGroupsLoaded: false,
    adminMode: false
}
export default {
    state,
    getters,
    actions,
    mutations
}
